import {
    PublicBlendedCourse,
    PublicClassCourse,
    PublicEducator,
} from '@cademy-package/sdk-component-types';
import { FunctionComponent, useMemo } from 'react';
import { getWaitlistUrl } from '../../../../../../services/getWaitlistUrl';
import ButtonLink from '../../../../../ButtonLink';
import { useIsMarketplace } from '../../../../../../contexts/AppContext/useIsMarketplace';
import { useIsEmbed } from '../../../../../../contexts/AppContext/useIsEmbed';

type WaitlistButtonProps = {
    course: PublicClassCourse | PublicBlendedCourse;
    educator: PublicEducator;
};

export const WaitlistButton: FunctionComponent<WaitlistButtonProps> = ({ course, educator }) => {
    const isMarketplace: boolean = useIsMarketplace();
    const isEmbed: boolean = useIsEmbed();
    const waitlistUrl: string = useMemo(
        () => getWaitlistUrl({ course, educator, isMarketplace, isEmbed }),
        [course, educator, isMarketplace, isEmbed]
    );

    return (
        <ButtonLink href={waitlistUrl} preset="warning">
            Join Waitlist
        </ButtonLink>
    );
};
